import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../util/theme';

const FooterWrapper = styled.footer`
  background-color: ${getColor('black')};

  a,
  p {
    color: ${getColor('white')};
    font-size: 1.4rem;
  }

  a {
    &:hover {
      color: ${getColor('accentGreen')};
    }
  }
`;

export default FooterWrapper;
